import * as React from "react"
import createSvgIcon from "./utils/create_icon"

const ShareOutline = createSvgIcon(<path fillRule="evenodd" clipRule="evenodd" d="M18 9a3 3 0 1 0-2.977-2.63l-6.94 3.47a3 3 0 1 0 0 4.319l6.94 3.47a3 3 0 1 0 .895-1.789l-6.94-3.47a3.03 3.03 0 0 0 0-.74l6.94-3.47C16.456 8.68 17.19 9 18 9Zm0-2a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM6 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm13 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z" fill="currentColor" />, "ShareOutline")
export default ShareOutline
